import { render, staticRenderFns } from "./Langues.vue?vue&type=template&id=fa7605ba"
import script from "./Langues.vue?vue&type=script&lang=js"
export * from "./Langues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports